module.exports = __webpack_public_path__ + "img/file-contractual.4a206ea9.png";